import React, { useEffect } from 'react'

import Box from 'components_new/atoms/Box'

import EmbeddedDashboard from 'components_new/organisms/EmbeddedDashboard'

import Author from './Author'
import Content from './Content'
import Header from './Header'
import MetricList from './MetricList'
import Systems from './Systems'
import Tags from './Tags'

import Loading from './loading'
import { useParams } from 'utils/hooks'
import { useTranslation } from 'language/translator'
import { useDashboardExampleActions } from 'redux/actions/DashboardExamples'
import {
  useDashboardExample,
  useDashboardExamplesFetchStatus
} from 'redux/hooks/DashboardExamples'

interface DashboardExampleProps {
  sx?: object
}

const DashboardExample = (props: DashboardExampleProps) => {
  const { sx } = props

  const params = useParams<{ id: string }>()
  const { lang } = useTranslation()

  const { tryGetAllDashboardExamples, tryAddDashboardExampleVisit } =
    useDashboardExampleActions()

  const fetchStatus = useDashboardExamplesFetchStatus()
  const dashboard = useDashboardExample(params.id)

  useEffect(() => {
    if (dashboard) {
      tryAddDashboardExampleVisit(dashboard.id)
    }
  }, [dashboard])

  useEffect(() => {
    if (fetchStatus === 'idle') {
      tryGetAllDashboardExamples()
    }
  }, [fetchStatus])

  if (!dashboard) return <Loading />

  return (
    <>
      <Box
        sx={{
          ...sx
        }}
      >
        <Header dashboard={dashboard} />

        <MetricList dashboard={dashboard} />

        <EmbeddedDashboard id={dashboard.id} sx={{ mt: 2, mb: 4 }} />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 12
          }}
        >
          <Box sx={{ maxWidth: 'content' }}>
            <Content
              body={dashboard.body[lang]}
              hint={dashboard.hint[lang]}
              summary={dashboard.summary[lang]}
            />
            <Systems systems={dashboard.systems} />
          </Box>

          <Box sx={{ width: 324 }}>
            <Tags dashboard={dashboard} sx={{ mb: 2 }} />

            <Author dashboard={dashboard} />
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default DashboardExample
